import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from "@/shared/components/ui/sidebar";
import { ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "@/shared/hooks/useAppContext";
import { useUserEstates } from "@/shared/hooks/useUserEstates";
import { usePersonPhotoUrl } from "@/shared/hooks/usePersonPhotoUrl";
import { POST_LOSS_ROUTES } from "@/shared/constants/paths";
import fallbackImage from "@/shared/assets/backgrounds/sunset.png";

export function TeamSwitcher() {
  const { person } = useAppContext();
  const { userEstates, isLoading: isLoadingPersons } = useUserEstates();
  const navigate = useNavigate();

  const { photoUrl, isLoading: isLoadingPhoto } = usePersonPhotoUrl(person?.estate_id || null);

  if (userEstates.length === 0 && !isLoadingPersons) {
    return null;
  }

  const currentPerson = userEstates.find((p) => p.estate_id === person?.estate_id);
  const firstName = currentPerson?.person?.first_name || "";
  const displayName = firstName ? `${firstName}'s Estate` : "Estate Details";

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        {isLoadingPersons ? (
          <div className="flex items-center gap-3 rounded-md border-[0.5px] border-primary p-3">
            <div className="size-8 rounded-full bg-subtle animate-pulse"></div>
            <div className="flex-1">
              <div className="w-24 h-4 bg-subtle rounded-sm animate-pulse"></div>
            </div>
          </div>
        ) : (
          <SidebarMenuButton
            size="lg"
            className="h-auto px-3 py-3 border-[0.5px] border-primary rounded-md focus-visible:ring-0 ring-0 hover:bg-subtle"
            onClick={() => navigate(POST_LOSS_ROUTES.SUMMARY)}
          >
            <div className="flex size-8 items-center justify-center rounded-full overflow-hidden flex-shrink-0">
              {isLoadingPhoto ? (
                <div className="w-full h-full bg-stone-300 animate-pulse rounded-full"></div>
              ) : (
                <img
                  src={photoUrl || fallbackImage}
                  alt={displayName}
                  className="w-full h-full object-cover"
                />
              )}
            </div>
            <p className="flex-1 truncate text-sm font-medium">{displayName}</p>
            <ChevronRight className="ml-auto size-4 text-primary" />
          </SidebarMenuButton>
        )}
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
